<template>
  <div class="recuperacion">
    <h1>Recuperación de contraseña</h1>
    <p>
      Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu
      contraseña.
    </p>
    <form @submit.prevent="enviarCorreoRecuperacion">
      <input type="email" v-model="correo" placeholder="Ingresa tu correo" required />
      <button type="submit">Enviar</button>
    </form>
    <p v-if="mensaje">{{ mensaje }}</p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      correo: "",
      mensaje: "",
      cargando: false,
    };
  },
  methods: {
    async enviarCorreoRecuperacion() {
      this.cargando = true;
      try {
        const response = await axios.post(
          this.$backendUrl + "token.php",
          { correo: this.correo }, // Enviando en JSON
          { headers: { "Content-Type": "application/json" } } // Asegurando formato JSON
        );
        alert(
          response.data.message || "Solicitud procesada con éxito. Revisa tu correo."
        );
      } catch (error) {
        console.error("Error en la solicitud:", error.response?.data);
        alert(
          error.response?.data?.message ||
            "Ocurrió un error al procesar la solicitud. Intenta nuevamente."
        );
      }
    },
  },
};
</script>

<style scoped>
.recuperacion {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 20px;
}

h1 {
  text-align: center;
}

input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #e5a61d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #e5a61d;
}
</style>
